'use client';

import clsx from 'clsx';
import { UIComponent } from '../..';
import { Icon } from '../../atoms';
import * as styles from './like.styles';

const Like: UIComponent<{}, 'i'> = ({ className, ...props }) => {
  return <Icon {...props} name="like" className={clsx(styles.like, className)} />;
};

export default Like;
